import Page from "@/components/layout/Page";

export default function SENDSchools() {
  return (
    <div className="min-h-screen overflow-hidden bg-gradient-to-b from-[#020817] via-[#04151F] to-[#020817] text-slate-50">
      <Page>
        <section className="w-full pb-24">
          <div className="max-w-[1280px] mx-auto px-6">
          <h1 className="text-[54px] leading-[1.1] font-bold mb-6 page-title-gradient">SEND Schools</h1>
          
          <div className="space-y-6 max-w-3xl">
            <p className="text-xl text-muted-foreground leading-relaxed">
              Supporting special educational needs with tactile sensory tools for learning and development.
            </p>
            
            <p className="text-lg leading-relaxed">
              Samboards products are particularly helpful to students who suffer from any condition affecting learning and concentration. Our sensory tools provide essential support for children with ADHD, autism, sensory processing disorders, and other learning differences.
            </p>
            
            <p className="text-lg leading-relaxed">
              In SEND schools, our products help create calm, focused learning environments. They can be used during lessons to support concentration, in sensory rooms for regulation, during transitions to ease anxiety, or as part of individual behaviour support plans.
            </p>
            
            <p className="text-lg leading-relaxed">
              Teachers and teaching assistants find our products invaluable for helping students self-regulate their emotions and maintain focus during challenging tasks. The tactile feedback provides a grounding sensory input that helps students stay present and engaged with their learning.
            </p>
            
            <p className="text-lg leading-relaxed">
              Our products should be used in conjunction with programmes recommended by Occupational Therapists and educational professionals, as part of a holistic approach to supporting each child's individual needs.
            </p>
          </div>
        </div>
      </section>
      </Page>
    </div>
  );
}
